import type {
    ComposableOptionsBase,
    GiftCardResponse,
    SiteMembershipContext
} from '~/types';
import type { NitroFetchOptions } from 'nitropack';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { FetchError } from 'ofetch';

export interface UseGiftCardsOptions extends ComposableOptionsBase {
    siteMembershipContext?: SiteMembershipContext;
}
export function useGiftCards(options: Partial<UseGiftCardsOptions> = {}) {
    const apiBasePath = '/v1/gift-cards';
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function checkBalance(code: string): Promise<GiftCardResponse | Error> {
        const url = `${apiBasePath}/${code}/`;
        const config: NitroFetchOptions<string> = {
            method: 'GET'
        };

        try {
            return await $_fetch<GiftCardResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorFromGenericApiErrorResponse(err as FetchError) || err as Error;
        }
    }

    async function redeem(code: string): Promise<GiftCardResponse | Error> {
        const url = `${apiBasePath}/${code}/redeem/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST'
        };

        try {
            return await $_fetch<GiftCardResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorFromGenericApiErrorResponse(err as FetchError) || err as Error;
        }
    }

    return {
        redeem,
        checkBalance
    };
}
